import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9f84ab8e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=9f84ab8e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84ab8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f84ab8e')) {
      api.createRecord('9f84ab8e', component.options)
    } else {
      api.reload('9f84ab8e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9f84ab8e&scoped=true", function () {
      api.rerender('9f84ab8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/mallManagement/serviceList/detail.vue"
export default component.exports